import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { dateOnlyBodyTemplate } from '../../../../../utils/dateUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const ClaimLimitTable = ({ claimLimits, loading, totalCount, lazyParams, onPage, onSort, onEdit, onDelete }) => {
    const { th } = useLanguage();

    const responsibleTemplate = (rowData) => {
        if (!rowData.responsibleList || !Array.isArray(rowData.responsibleList)) {
            return '-';
        }
        return rowData.responsibleList.map((responsible) => responsible.name).join(', ');
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <i onClick={() => onEdit(rowData)} className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warrantyClaimLimit.tooltips.edit')}></i>
                <i onClick={() => onDelete(rowData.id)} className="pi pi-trash cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warrantyClaimLimit.tooltips.delete')}></i>
                <i className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warrantyClaims.tooltips.history')}></i>
            </div>
        );
    };

    return (
        <DataTable
            value={claimLimits}
            paginator
            rows={lazyParams.rows}
            totalRecords={totalCount}
            lazy
            first={lazyParams.first}
            className="p-datatable-gridlines"
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            loading={loading}
            emptyMessage={th('warrantyClaimLimit.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            sortMode="single"
            removableSort
        >
            <Column body={actionTemplate} style={{ width: '10%' }} align="center" />
            <Column field="startDate" header={th('warrantyClaimLimit.columns.startDate')} body={(rowData) => dateOnlyBodyTemplate(rowData, 'startDate')} sortable />
            <Column field="endDate" header={th('warrantyClaimLimit.columns.endDate')} body={(rowData) => dateOnlyBodyTemplate(rowData, 'endDate')} sortable />
            <Column field="productGroup" header={th('warrantyClaimLimit.columns.productGroup')} sortable />
            <Column field="carItemCode" header={th('warrantyClaimLimit.columns.carItemCode')} sortable />
            <Column field="warrClaimLimits" header={th('warrantyClaimLimit.columns.warrClaimLimits')} sortable />
            <Column field="warrClaimLimitsCurrUnits" header={th('warrantyClaimLimit.columns.warrClaimLimitsCurrUnits')} sortable />
            <Column field="responsibleList" header={th('warrantyClaimLimit.columns.responsible')} body={responsibleTemplate} sortable />
        </DataTable>
    );
};

export default ClaimLimitTable;
